var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSubheaderHeadphones(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.9642 32.866L45.8302 33.366C48.2217 34.7467 49.041 37.8047 47.6603 40.1962L45.6603 43.6603C44.2796 46.0517 41.2217 46.8711 38.8302 45.4904L37.9642 44.9904L44.9642 32.866Z",
    stroke: "#4F7FA7",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.433 31.9821C41.7596 31.4164 42.3989 31.144 43.0064 31.2569L35.5917 44.0995C35.1901 43.6298 35.1065 42.94 35.433 42.3744L41.433 31.9821Z",
    stroke: "#4F7FA7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5622 32.866L9.69617 33.366C7.30471 34.7467 6.48533 37.8047 7.86604 40.1962L9.86604 43.6603C11.2468 46.0517 14.3047 46.8711 16.6962 45.4904L17.5622 44.9904L10.5622 32.866Z",
    stroke: "#4F7FA7",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0934 31.9821C13.7668 31.4164 13.1275 31.144 12.52 31.2569L19.9347 44.0995C20.3362 43.6298 20.4199 42.94 20.0934 42.3744L14.0934 31.9821Z",
    stroke: "#4F7FA7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8591 33C46.5973 30.9324 47 28.7004 47 26.3726C47 15.6734 38.4934 7 28 7C17.5066 7 9 15.6734 9 26.3726C9 28.7004 9.40269 30.9324 10.1409 33",
    stroke: "#4F7FA7",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M45 17.1961C41.6581 11.1104 35.2973 7 28 7C20.7027 7 14.3419 11.1104 11 17.1961",
    stroke: "#4F7FA7",
    strokeWidth: 4,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubheaderHeadphones);
export default __webpack_public_path__ + "static/media/subheader-headphones.b573e72d6d0dbbac6bb1c52e86da88cf.svg";
export { ForwardRef as ReactComponent };